import { useEffect } from "react";
import { UBAppModal } from "../../../../Libraries";
import UBDateSelect from "../../../../Libraries/UBDateSelect";
import styles from "./styles.module.css";
import { Box } from "@mui/material";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

const OrderReturnModal = ({ header, body, footer }) => {
  const {
    toggleReturnModal: handleClose,
    toggle,
    onChangeText
  } = body || {};

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (toggle) {
        if (event.key === 'Escape') {
          // Close the modal when the 'Escape' key is pressed
          handleClose()
        } else if (event.key === 'Enter' && footer?.length && !footer[1]?.data?.disabled) {
          footer?.length && footer[1]?.data?.onClick(); // Trigger an action when the 'Enter' key is pressed
        }
      }
    };

    // Add the event listener when the modal is open
    if (toggle) {
      window.addEventListener('keydown', handleKeyDown);
    }

    // Remove the event listener when the component unmounts
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [toggle, footer]);

  return (
    <UBAppModal
      id="order_return_modal"
      open={toggle}
      header={{
        handleClose: () => handleClose(),
        dont_show_cross_icon: true,
        ...header
      }}
      className={styles.OrderReturnModal}
      footer={footer}
    >
      <Box className={styles.markAsPaidDateBoxWrapper}>
        <UBDateSelect
          id="order_date"
          selectedDate={body.selected}
          setSelectedDate={(date) => {
            triggerLogEvent(analytics, "sc_order_return_date_selected");
            onChangeText(date);
          }}
          title={null}
          placeholder={body.placeholderText}
          isCalendericon
        />
      </Box>  </UBAppModal>
  );
};

export default OrderReturnModal;
